export const GOOGLE_ANALYTICS_ID = 'G-B2KHWZY3NS'

const KLARO_COOKIE_NAME = 'easymillions_fr_consent'
const PRIVACY_PATH = '/page/protectiondesdonnees'
const PRIVACY_LABEL = 'Protection des données'
const GA_DISABLE_KEY = `ga-disable-${GOOGLE_ANALYTICS_ID}`
const KLARO_RUNTIME_SCRIPT_ID = 'klaro-runtime'
const KLARO_CONFIG_SCRIPT_ID = 'klaro-config'
const KLARO_STYLESHEET_ID = 'klaro-stylesheet'

const isAnalyticsHost = () => window.location.hostname === 'easymillions.fr'

const getAnalyticsWindow = () => window

const ensureGtag = () => {
  const analyticsWindow = getAnalyticsWindow()

  analyticsWindow.dataLayer = analyticsWindow.dataLayer || []
  analyticsWindow.gtag =
    analyticsWindow.gtag ||
    function gtag() {
      analyticsWindow.dataLayer.push(arguments)
    }

  return analyticsWindow.gtag
}

const setAnalyticsDisabled = disabled => {
  getAnalyticsWindow()[GA_DISABLE_KEY] = disabled
}

const configureGoogleAnalytics = () => {
  if (!isAnalyticsHost()) {
    return
  }

  const analyticsWindow = getAnalyticsWindow()
  const gtag = ensureGtag()

  if (!analyticsWindow.__klaroGaScriptLoaded) {
    const script = document.createElement('script')

    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`
    script.setAttribute('data-klaro-ga', 'true')
    document.head.appendChild(script)
    analyticsWindow.__klaroGaScriptLoaded = true
  }

  if (!analyticsWindow.__klaroGaConfigured) {
    gtag('js', new Date())
    gtag('config', GOOGLE_ANALYTICS_ID, {
      send_page_view: false
    })
    analyticsWindow.__klaroGaConfigured = true
  }
}

const trackPageView = location => {
  if (!isAnalyticsHost()) {
    return
  }

  const analyticsWindow = getAnalyticsWindow()

  if (!analyticsWindow.__klaroGaConfigured || typeof analyticsWindow.gtag !== 'function') {
    return
  }

  if (analyticsWindow[GA_DISABLE_KEY]) {
    return
  }

  analyticsWindow.gtag('event', 'page_view', {
    page_path: location.pathname + location.search + location.hash,
    page_search: location.search,
    page_hash: location.hash
  })
}

const onAnalyticsConsent = consent => {
  setAnalyticsDisabled(!consent)

  if (!consent) {
    return
  }

  configureGoogleAnalytics()
  trackPageView(window.location)
}

const getKlaroConfigScript = () => `
window.klaroConfig = {
  version: 1,
  elementID: "klaro",
  storageMethod: "cookie",
  cookieName: "${KLARO_COOKIE_NAME}",
  cookieExpiresAfterDays: 180,
  default: false,
  mustConsent: false,
  acceptAll: true,
  hideDeclineAll: false,
  hideLearnMore: false,
  noticeAsModal: false,
  groupByPurpose: true,
  lang: "fr",
  translations: {
    zz: {
      privacyPolicyUrl: "${PRIVACY_PATH}"
    },
    fr: {
      privacyPolicyUrl: "${PRIVACY_PATH}",
      privacyPolicy: {
        name: "${PRIVACY_LABEL}",
        text: "Pour en savoir plus, consultez notre page {privacyPolicy}."
      },
      decline: "Je refuse",
      ok: "J’accepte",
      consentNotice: {
        description: "Acceptez-vous l'activation de services optionnels pour le bon fonctionnement du site & la mesure d'audience ? Vous pourrez modifier votre choix à tout moment depuis notre page ${PRIVACY_LABEL}.",
        learnMore: "Je préfère choisir",
        privacyPolicy: {
          name: "${PRIVACY_LABEL}"
        }
      },
      consentModal: {
        title: "Gestion des cookies",
        description: "Choisissez ici les services optionnels que nous pouvons activer sur ce site. Les cookies strictement necessaires au fonctionnement du compte restent actifs.",
        privacyPolicy: {
          name: "${PRIVACY_LABEL}",
          text: "Pour en savoir plus, consultez notre page {privacyPolicy}."
        }
      },
      googleAnalytics: {
        title: "Google Analytics",
        description: "Mesure d'audience du site et de ses parcours de navigation."
      },
      necessaryCookies: {
        title: "Cookies necessaires",
        description: "Assurent le maintien de la session, la memorisation de la langue et l'enregistrement de votre choix de consentement."
      },
      purposes: {
        necessary: {
          title: "Fonctionnement du site",
          description: "Ces cookies sont necessaires au bon fonctionnement du site et ne peuvent pas etre desactives depuis le gestionnaire."
        },
        analytics: {
          title: "Mesure d'audience",
          description: "Ces services nous aident a comprendre la frequentation du site et a ameliorer son fonctionnement."
        }
      }
    }
  },
  services: [
    {
      name: "necessaryCookies",
      title: "Cookies necessaires",
      purposes: ["necessary"],
      required: true,
      default: true,
      cookies: [
        [/^token$/, "/", window.location.hostname],
        [/^language$/, "/", window.location.hostname],
        [/^${KLARO_COOKIE_NAME}$/, "/", window.location.hostname]
      ]
    },
    {
      name: "googleAnalytics",
      title: "Google Analytics",
      purposes: ["analytics"],
      default: false,
      onlyOnce: true,
      cookies: [
        [/^_ga$/, "/", window.location.hostname],
        [/^_ga_.*/, "/", window.location.hostname],
        [/^_gid$/, "/", window.location.hostname]
      ],
      callback: function(consent) {
        window.__easymillionsHandleAnalyticsConsent(consent)
      }
    }
  ]
};
`

const injectScriptTag = ({ id, content, src }) => {
  if (document.getElementById(id)) {
    return
  }

  const script = document.createElement('script')
  script.id = id

  if (content) {
    script.text = content
  }

  if (src) {
    script.src = src
    script.async = true
  }

  document.body.appendChild(script)
}

const injectStylesheet = () => {
  if (document.getElementById(KLARO_STYLESHEET_ID)) {
    return
  }

  const link = document.createElement('link')
  link.id = KLARO_STYLESHEET_ID
  link.rel = 'stylesheet'
  link.href = '/vendor/klaro/klaro.css'
  document.head.appendChild(link)
}

export const openCookieSettings = () => {
  const klaroWindow = window

  if (klaroWindow.klaro && klaroWindow.klaroConfig) {
    klaroWindow.klaro.show(klaroWindow.klaroConfig, true)
  }
}

export const initCookieConsent = history => {
  if (window.__easymillionsCookieConsentInitialized) {
    return
  }

  window.__easymillionsCookieConsentInitialized = true
  window.__easymillionsHandleAnalyticsConsent = onAnalyticsConsent

  setAnalyticsDisabled(true)
  injectStylesheet()
  injectScriptTag({
    id: KLARO_CONFIG_SCRIPT_ID,
    content: getKlaroConfigScript()
  })
  injectScriptTag({
    id: KLARO_RUNTIME_SCRIPT_ID,
    src: '/vendor/klaro/klaro.js'
  })

  history.listen(location => {
    trackPageView(location)
  })
}
